"use strict";

exports.__esModule = true;
exports.RealtimeDataSubscription = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _createSubscription = require("../../../Utils/createSubscription");
var _RealtimeConnectionContext = require("./RealtimeConnectionContext");
var _excluded = ["realtime", "params", "children"];
var _dec, _class, _RealtimeDataSubscription;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var InnerSubscription = (0, _createSubscription.createSubscription)({
  getCurrentValue: function getCurrentValue(_ref) {
    var cache = _ref.cache,
      params = _ref.params,
      defaultValue = _ref.defaultValue,
      normalize = _ref.normalize;
    if (cache === undefined) {
      return defaultValue;
    }
    var fromCache = cache.getCachedValue(params);
    if (fromCache === undefined) {
      return defaultValue;
    }
    return normalize(fromCache);
  },
  subscribe: function subscribe(_ref2, callback) {
    var cache = _ref2.cache,
      params = _ref2.params,
      onData = _ref2.onData,
      normalize = _ref2.normalize;
    if (cache === undefined) {
      return function () {};
    }
    var subscription = cache.subscribe(params, {
      next: function next(data) {
        var value = normalize(data);
        if (typeof onData === "function") {
          onData(value);
        }
        callback();
      },
      complete: function complete() {
        return undefined;
      },
      error: callback
    });
    return function () {
      return subscription.unsubscribe();
    };
  }
});

/**
 * A subscription to a channel on a realtime connection.
 */
var RealtimeDataSubscription = exports.RealtimeDataSubscription = (_dec = _RealtimeConnectionContext.RealtimeConnectionContext.withContext, _dec(_class = (_RealtimeDataSubscription = /*#__PURE__*/function (_Component) {
  function RealtimeDataSubscription() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = makeState(_this.props);
    return _this;
  }
  _inheritsLoose(RealtimeDataSubscription, _Component);
  RealtimeDataSubscription.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.realtime.connection === prevState.connection && (0, _reactFastCompare["default"])(props.params, prevState.params)) {
      return null;
    }
    return makeState(props);
  };
  var _proto = RealtimeDataSubscription.prototype;
  _proto.render = function render() {
    // eslint-disable-next-line no-unused-vars
    var _this$props = this.props,
      realtime = _this$props.realtime,
      params = _this$props.params,
      children = _this$props.children,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_react["default"].createElement(InnerSubscription, _extends({
      source: this.state
    }, extra), children);
  };
  return RealtimeDataSubscription;
}(_react.Component), _RealtimeDataSubscription.defaultProps = {
  realtime: undefined,
  defaultValue: undefined,
  normalize: function normalize(input) {
    return input;
  }
}, _RealtimeDataSubscription)) || _class);
function makeState(_ref3) {
  var realtime = _ref3.realtime,
    params = _ref3.params,
    onData = _ref3.onData,
    defaultValue = _ref3.defaultValue,
    normalize = _ref3.normalize;
  var connection = realtime.connection,
    cache = realtime.cache;
  return {
    connection: connection,
    cache: cache,
    params: params,
    onData: onData,
    defaultValue: defaultValue,
    normalize: normalize
  };
}